import SubscribeContainer from "./containers/SubscribeContainer";
import "./styles.scss";

export default SubscribeContainer;
